module.exports = __webpack_public_path__ + "static-v-shop/1765574824275/img/logo_cabal.f797e5ff.png";